import React from 'react'
import { Button, Divider, Header, Icon, Table } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import PermissionsManager from '../PermissionsManager'

const Authors = props => {
  if (!props.authors || props.authors.length === 0) {
    return <div>
      Aucun enregistrement
      <PermissionsManager hasPermissions={['create_author']}>
        <Button as={ Link } name='new' to='/blog/authors/new' floated="right" icon labelPosition="left" color="olive" size="small">
          <Icon name="marker" /> Ajouter un auteur
        </Button>
      </PermissionsManager>
    </div>
  }

  return (
    <div>
      <Header as="h1">Auteurs</Header>
      <Table selectable singleLine color="red">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Nom</Table.HeaderCell>
            <Table.HeaderCell>Dernière modification</Table.HeaderCell>
            <Table.HeaderCell>Action</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {props.authors.map(author => {
            return (
              <Table.Row key={author.id}>
                <Table.Cell>
                  {author.name}
                </Table.Cell>
                <Table.Cell>
                  {author.updated_at}
                </Table.Cell>
                <Table.Cell>
                  <Button as={ Link } name="author" to={`authors/${author.id}`} icon size="small">
                    <Icon name='pencil'/>
                  </Button>
                </Table.Cell>
              </Table.Row>
            )
          })}
        </Table.Body>

        <PermissionsManager hasPermissions={['create_author']}>
          <Table.Footer>
            <Table.Row>
              <Table.HeaderCell colSpan="4">
                <Button as={ Link } name='new' to='/blog/authors/new' floated="right" icon labelPosition="left" color="olive" size="small">
                  <Icon name="marker" /> Ajouter un auteur
                </Button>
                <Divider hidden={true} />
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </PermissionsManager>
      </Table>
    </div>
  )
}

export default Authors



// WEBPACK FOOTER //
// ./src/components/list/Authors.js